import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';
import { getAccountName } from '../../lib/accountMap';
import DyrejournalReportSalesAndPayments from '../../components/dyrejournal/reportSalesAndPayments';

import FormFields from '../../components/form/fields';
import Input from '../../components/form/input';

const MARKDOWN_OPTIONS = {
    pedantic: false,
    gfm: true,
    breaks: true,
    sanitize: false,
    smartLists: true,
    smartypants: true,
    xhtml: true,
    highlight: function(code, lang) {
        const hljs = require('highlight.js');
        const language = hljs.getLanguage(lang) ? lang : 'plaintext';
        return hljs.highlight(code, { language }).value;
    },
    langPrefix: 'hljs language-', // highlight.js css expects a top-level 'hljs' class.
};

const REPORT_TYPES_WITH_TOTALS = ['day', 'periode', 'z-report', 'month', 'year'];

const MONTH_NAMES = [
    'jan', 'feb', 'mar', 'apr', 'mai', 'jun',
    'jul', 'aug', 'sep', 'okt', 'nov', 'des',
];

function getReportDate(inputDate, reportType, onlyFromDate) {
    const reportDate = new Date(`${inputDate}T00:00:00`);
    // console.log({ inputDate, reportDate})
    // console.log({ reportType })
    const reportDay = reportDate.getDate();
    const reportMonth = reportDate.getMonth();
    const reportYear = reportDate.getFullYear();

    if (reportType === 'day') {
        return `${reportDay}.${MONTH_NAMES[reportMonth]} ${reportYear}`;
    } else if (reportType === 'z-report') {
        return `${reportDay}.${MONTH_NAMES[reportMonth]} ${reportYear}`;
    } else if (reportType === 'month') {
        return `${onlyFromDate ? reportDay : 1} - ${util.daysInMonth(reportMonth + 1, reportYear)}.${MONTH_NAMES[reportMonth]} ${reportYear}`;
    } else if (reportType === 'year') {
        return `1.jan - 31.des ${reportYear}`;
    }
    return '';//`${reportDay}.${MONTH_NAMES[reportMonth]} ${reportYear}`;
}

@withText(props => ({
    orderNumber: <Text id='input.orderNumber-help'>orderNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    installation: <Text id='input.installation-help'>installation</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class ReportsPrint extends Component {
  	constructor(props) {
        super(props);
        this.state = {
        };
    }

//     loadAll = async () => {
//         const { id } = this.props;
// console.log('reportPrint', { id })
//         const { saleReportStore } = this.props.stores;
//         await saleReportStore.load(id);
//     }

//     componentDidMount() {
//         this.loadAll();
//     }

    render() {
        const { week, isNew, drawerLevel, journals = [] } = this.props;
        const { sections } = this.state;
        const { customerStore, userStore, saleStore, saleReportStore } = this.props.stores;
        const { customer } = userStore;
        const { user, isAdmin } = userStore;

        const { saleReport = {} } = saleReportStore;

        const darkmode= util.getNestedValue(user, 'settings.darkmode');
        const {
            saleTotal = 0,
            saleTax = 0,
            newSale = {},
        } = saleStore;
        // const saleIsLocked = !!newSale.paymentMethod;
        // console.log({ newSale })

        const { animalStore, appState } = this.props.stores;
        const { animal, owners } = animalStore;
        const { view = {} } = appState;

        const {
            totalNumberOfSales,
            aggSaleTotal,
            aggSaleTotalNew,
            aggSaleTotalPaymentMethods,
            aggSaleTotalTax,
        } = saleStore;

        if (!saleReport) {
            return (<></>);
        }

        let totalForAccounts = 0;
        let totalForAccountsIncVat = 0;
        if (saleReport.saleAccounts) {
            totalForAccounts = saleReport.saleAccounts.map(account => account.price).reduce((a, b) => a + b, 0);
            // Gross per account comes from the backend at each line's own VAT rate.
            // Reports saved before that field existed keep the old flat 25 % figure. TICKET-01539.
            totalForAccountsIncVat = saleReport.saleAccounts
                .map(account => (account.priceIncVat ?? (account.price || 0) * 1.25))
                .reduce((a, b) => a + b, 0);
        }

        return (<>
            <div class='receipt'>
                <div class='d-flex flex-column receipt'>
                    <div class='d-flex flex-row justify-content-between'>
                        <div class='text-center d-flex align-items-center'>
                            {customer.images && customer.images.length > 0 && <img src={localUtil.displayImg(customer.images[0], this.props, '220x')} class='img-fluid' style='max-height: 100px;' />}
                        </div>
                        <div class='d-flex flex-fill align-items-center'>
                            <span class='font-weight-bolder'>{customer.name}</span>
                        </div>
                    </div>
                    <div class='d-flex flex-row justify-content-between mt-2'>
                        <div class='col-12 d-flex flex-column align-items-end'>
                            <div class='d-flex flex-row'><Text id='dyrejournal.report-date'>Report Date:</Text>
                            {saleReport.reportType === 'periode' ? <>
                                {util.isoDate(saleReport.reportDateTimeStart, true)} - {util.isoDate(saleReport.reportDateTimeEnd, true)}
                            </> : <>
                                {getReportDate(util.isoDate(saleReport.reportDate, false, false, true), saleReport.reportType)}
                            </>}
                            </div>
                            <div class='d-flex flex-row'><Text id='dyrejournal.responsible'>Responsible:</Text> {user.firstname} {user.lastname}</div>
                        </div>
                    </div>

                    <hr />

                    <div class='d-flex flex-column mt-3'>
                        <div class='w-100 d-flex flex-column'>
                            <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                                {saleReport.reportType === 'day' && <>
                                    <Text id='dyrejournal.report.daily'>Daily</Text>
                                </>}
                                {saleReport.reportType === 'periode' && <>
                                    <Text id='dyrejournal.report.periode'>Periode</Text>
                                </>}
                                {saleReport.reportType === 'z-report' && <>
                                    <Text id='dyrejournal.report.z-report'>Z-Report</Text>
                                </>}
                                {saleReport.reportType === 'month' && <>
                                    <Text id='dyrejournal.report.monthly'>Monthly</Text>
                                </>}
                                {saleReport.reportType === 'year' && <>
                                    <Text id='dyrejournal.report.yearly'>Yearly</Text>
                                </>}
                            </div>
                            <div class={`d-flex flex-column py-3 box-container`}>
                                {REPORT_TYPES_WITH_TOTALS.includes(saleReport.reportType) && (
                                    <DyrejournalReportSalesAndPayments
                                        saleReport={saleReport}
                                        reportType={saleReport.reportType}
                                        showCreditCard={false}
                                        showConvene={(customer?.featureFlags?.convenePayment || 0) > 0}
                                        editable={false}
                                        print
                                    />
                                )}

                                {/* <div class='table-responsive w-50'>
                                    <table class='table table-sm table-hover table-striped'>
                                        <tbody>
                                            <tr>
                                                <th><Text id='dyrejournal.report.total-sales'>Total sales</Text></th>
                                                <td style='text-align: right;'>{totalNumberOfSales}</td>
                                            </tr>
                                            <tr>
                                                <th><Text id='dyrejournal.report.total-amount-wo-tax'>Total amount wo/tax</Text></th>
                                                <td style='text-align: right;'>{util.format(saleStore.lineTotal(aggSaleTotal, true, 1), 2)}</td>
                                            </tr>
                                            <tr>
                                                <th><Text id='dyrejournal.report.total-tax'>Total tax</Text></th>
                                                <td style='text-align: right;'>{util.format(aggSaleTotal.tax, 2)}</td>
                                            </tr>
                                            <tr>
                                                <th><Text id='dyrejournal.report.total-number-of-products-services'>Total number of products/services</Text></th>
                                                <td style='text-align: right;'>{aggSaleTotal.count}</td>
                                            </tr>
                                            {aggSaleTotalPaymentMethods && aggSaleTotalPaymentMethods.map((item, idx) => {
                                                return (<>
                                                    <tr>
                                                        <th><Text id='dyrejournal.report.total-amount-wo-tax'>Total amount wo/tax for {item.paymentMethod}</Text></th>
                                                        <td style='text-align: right;'>{util.format(item.total, 2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><Text id='dyrejournal.report.total-tax'>Total tax for {item.paymentMethod}</Text></th>
                                                        <td style='text-align: right;'>{util.format(item.tax, 2)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th><Text id='dyrejournal.report.total-number-of-products-services'>Total number of products/services for {item.paymentMethod}</Text></th>
                                                        <td style='text-align: right;'>{item.count}</td>
                                                    </tr>
                                                </>);
                                            })}
                                        </tbody>
                                    </table>
                                </div> */}

                                {/* Report for today<br />
                                Total number of sales: {totalNumberOfSales}<br />
                                Total amount wo/tax: {util.format(aggSaleTotal.total, 2)}<br />
                                Total tax: {util.format(aggSaleTotal.tax, 2)}<br />
                                Total number of products/services: {aggSaleTotal.count}<br />

                                {aggSaleTotalPaymentMethods && aggSaleTotalPaymentMethods.map((item, idx) => {
                                    return (<>
                                        Total amount wo/tax for {item.paymentMethod}: {util.format(item.total, 2)}<br />
                                        Total tax for {item.paymentMethod}: {util.format(item.tax, 2)}<br />
                                        Total number of products/services for {item.paymentMethod}: {item.count}<br />
                                    </>);
                                })} */}
                                {/* Total appointments: 0<br />
                                Total journals: 0<br />
                                Total prescriptions: 0<br />
                                Total animals: 0<br /> */}

                                {/* <xmp>{JSON.stringify(aggSaleTotal, null, 2)}</xmp>
                                <xmp>{JSON.stringify(aggSaleTotalPaymentMethods, null, 2)}</xmp>
                                <xmp>{JSON.stringify(aggSaleTotalTax, null, 2)}</xmp> */}
                            </div>
                        </div>
                        <div class='w-100 d-flex flex-column'>
                            {saleReport.comment && <div class='d-flex flex-column'>
                                <div class='font-weight-lighter box-header d-flex flex-row justify-content-between'>
                                    <Text id='dyrejournal.report.comment'>Comment</Text>
                                </div>
                                <div class=''>
                                    <Markdown markdown={saleReport.comment} markedOpts={MARKDOWN_OPTIONS} />
                                </div>
                            </div>}
                        </div>
                    </div>


                    {saleReport.salesPersons && saleReport.salesPersons.length > 0 && <>
                        <div class='d-flex flex-column mt-3'>
                            <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                                <Text id='dyrejournal.report.user-sales'>Sales by user</Text>
                            </div>
                            <div class={`d-flex flex-column py-3 box-container`}>
                                <div class='table-'>
                                    <table class='table table-sm table-hover table-striped' style='font-size: 0.75em; line-height: 1.0em;'>
                                        <thead>
                                            <tr>
                                                <th><nobr><Text id='dyrejournal.report.user'>User</Text></nobr></th>
                                                <th style='text-align: right;'><nobr><Text id='dyrejournal.report.sales'>Sales</Text></nobr></th>
                                                <th style='text-align: right;'><nobr><Text id='dyrejournal.report.fee'>Fee</Text></nobr></th>
                                                <th style='text-align: right;'><nobr><Text id='dyrejournal.report.medicine'>Medicine</Text></nobr></th>
                                                <th style='text-align: right;'><nobr><Text id='dyrejournal.report.equipment'>Equipment</Text></nobr></th>
                                                <th style='text-align: right;'><nobr><Text id='dyrejournal.report.other'>Other</Text></nobr></th>
                                                <th style='text-align: right;'><nobr><Text id='dyrejournal.report.sum'>Sum</Text></nobr></th>
                                                <th style='text-align: right;'><nobr><Text id='dyrejournal.report.price-discount'>Discount</Text></nobr></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {saleReport.salesPersons && saleReport.salesPersons.map((userSale, idx) => {
                                                if (!userSale.user) {
                                                    return <></>;
                                                }
                                                const totalSales = userSale.accounts?.reduce((acc, item) => acc + item.saleCount, 0) || userSale.count || 0;
                                                // All buckets zero = the line has no split, so fall back to price. A
                                                // negative bucket is still a split (credit/correction). TICKET-01499.
                                                const hasOnlyPrice = !(userSale.fee || userSale.medicine || userSale.equipment || userSale.other);
                                                const sumTotal = hasOnlyPrice ? userSale.price : (userSale.fee + userSale.medicine + userSale.equipment + userSale.other);
                                                return (<>
                                                    <tr>
                                                        <td><nobr>{userSale.user.firstname} {userSale.user.lastname}</nobr></td>
                                                        <td style='text-align: right;'><nobr>{util.format(totalSales, 0)}</nobr></td>
                                                        <td style='text-align: right;'><nobr>{util.format(userSale.fee || 0, 2)}</nobr></td>
                                                        <td style='text-align: right;'><nobr>{util.format(userSale.medicine || 0, 2)}</nobr></td>
                                                        <td style='text-align: right;'><nobr>{util.format(userSale.equipment || 0, 2)}</nobr></td>
                                                        <td style='text-align: right;'><nobr>{hasOnlyPrice ? util.format(userSale.price || 0, 2) : util.format(userSale.other || 0, 2)}</nobr></td>
                                                        <td style='text-align: right;'><nobr>{util.format(sumTotal || 0, 2)}</nobr></td>
                                                        <td style='text-align: right;'><nobr>{util.format((userSale.discountAmount || 0) / 1.25, 2)}</nobr></td>
                                                    </tr>
                                                </>);
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class='w-100 d-flex flex-row justify-content-center'>
                                <small class='text-muted'>
                                    <Text id='dyrejournal.report.user-sales-help'>Sales by user. The sum is the total sale for this user without rounding price to nearest NOK. Tax is NOT included in the sum.</Text>
                                </small>
                            </div>
                        </div>
                    </>}

                    <div class='d-flex flex-column mt-3'>
                        <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                            <Text id='dyrejournal.report.account-sales'>Sales by account</Text>
                        </div>
                        <div class={`d-flex flex-column py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                            <div class='table-responsive w-50'>

                                <table class='table table-sm table-hover table-striped' style='font-size: 0.75em; line-height: 1.0em;'>
                                    <thead>
                                        <tr>
                                            <th><nobr><Text id='dyrejournal.report.account'>Account</Text></nobr></th>
                                            <th style='text-align: right;'><nobr><Text id='dyrejournal.report.sum'>Sum</Text></nobr></th>
                                            {/* <th style='text-align: right;'><Text id='dyrejournal.report.tax'>Tax inc</Text></th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {saleReport.saleAccounts && saleReport.saleAccounts.map(account => <>
                                            <tr>
                                                <td style='text-align: left;'>
                                                    <nobr>
                                                        {account.account || ''} {getAccountName(account.account, customer) || (!account.account ? 'Ingen konto' : '')}
                                                    </nobr>
                                                </td>
                                                <td style='text-align: right;'>
                                                    <nobr>
                                                        {util.format(account.price, 2)}
                                                    </nobr>
                                                </td>
                                                {/* <td style='text-align: right;'>
                                                    <nobr>
                                                        {util.format(saleStore.calculateTax(account.price), 2)}
                                                    </nobr>
                                                </td> */}
                                            </tr>
                                        </>)}
                                        <tr>
                                            <td class='font-weight-bold'><nobr><Text id='dyrejournal.report.total-ex-tax'>Total without tax</Text></nobr></td>
                                            <td class='font-weight-bold' style='text-align: right;'><nobr>{util.format(totalForAccounts, 2)}</nobr></td>
                                        </tr>
                                        <tr>
                                            <td class='font-weight-bold'><nobr><Text id='dyrejournal.report.total-inc-tax'>Total with tax</Text></nobr></td>
                                            <td class='font-weight-bold' style='text-align: right;'><nobr>{util.format(totalForAccountsIncVat, 2)}</nobr></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class='w-100 d-flex flex-row justify-content-center'>
                            <small class='text-muted'>
                                <Text id='dyrejournal.report.account-sales-help'>Sales by account. The sum is the total sale for this account without rounding price to nearest NOK. Tax is NOT included in the sum.</Text>
                            </small>
                        </div>
                    </div>


                    <div class='d-flex flex-row text text-muted mt-3'>
                        <Text id='dyrejournal.print-date'>Print Date:</Text> {util.formatDate(new Date(), { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })}
                    </div>
                    <hr class='mt-1' />

                    <div class='d-flex flex-row justify-content-between mt-3'>
                        <div class='d-flex flex-column'>
                            <small>
                                <div class='mb-2 font-weight-bold'><Text id='dyrejournal.business-register'>The Business Register</Text></div>
                                <div>{customer.orgNumber}</div>
                                <div>{customer.name}</div>
                                {customer.orgNumber2 && <div>{customer.orgNumber}</div>}
                                {customer.name2 && <div>{customer.name}</div>}
                            </small>
                        </div>
                        <div class='d-flex flex-column'>
                            <small>
                                <div class='mb-2 font-weight-bold'><Text id='dyrejournal.address'>Address</Text></div>
                                <div>{customer.address}</div>
                                <div>{customer.postalcode} {customer.place}</div>
                            </small>
                        </div>
                        <div class='d-flex flex-column'>
                            <small>
                                <div class='mb-2 font-weight-bold'>{customer.fax ? <Text id='dyrejournal.phone-fax'>Phone/Fax</Text> : <Text id='dyrejournal.phone'>Phone</Text>}</div>
                                <div>{customer.phone}</div>
                                {customer.fax ? <div>{customer.fax}</div> : null}
                            </small>
                        </div>
                        <div class='d-flex flex-column'>
                            <small>
                                <div class='mb-2 font-weight-bold'><Text id='dyrejournal.internett'>Internet</Text></div>
                                <div>{customer.url}</div>
                                <div>{customer.email}</div>
                            </small>
                        </div>
                    </div>

                </div>

            </div>
        </>);
    }
}

export default ReportsPrint;
